import { useDisclosure } from '@hooks/useDisclosure';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { GridActionsCellItem } from '@mui/x-data-grid';
import { useGreenhouseForm } from '@Router/EsgGreenhouse/Containers/EsgGreenhouseFormProvider';
import { ICarbonDetailFormValues } from '@Router/EsgGreenhouse/Containers/EsgGreenhouseFormProvider/types';
import ModalCarbonNeutrality from '../ModalCarbonNeutrality/ModalCarbonNeutrality';
type CarbonActionsProps = { rowId: number | string };

const CarbonNeutralityEditRow = ({ rowId }: CarbonActionsProps) => {
  const [opened, { open, close }] = useDisclosure();
  const { getValues, watch } = useGreenhouseForm();

  const isNewDetails = typeof rowId === 'string';
  const completedSection = watch('greenhouseGoalTerm.completedSection');

  const { isCompletedTh, isCompletedEn } = completedSection ?? {};

  const carbonDetails =
    getValues('greenhouseGoalTerm.carbon.details') ??
    ([] as Array<ICarbonDetailFormValues>);

  const currentDetails = opened
    ? carbonDetails.find((detail, index) => {
        if (isNewDetails)
          return index === Number(rowId.replace('NEW-', '')) - 1;
        return detail.id === rowId;
      })
    : undefined;

  const currentIndex = isNewDetails
    ? Number(rowId.replace('NEW-', '')) - 1
    : carbonDetails.findIndex((detail) => detail.id === rowId);

  return (
    <>
      <GridActionsCellItem
        key="edit"
        icon={<EditOutlinedIcon style={{ fontSize: '16px' }} />}
        label="Edit"
        onClick={open}
        disabled={isCompletedTh && isCompletedEn}
      />
      {opened && (
        <ModalCarbonNeutrality
          open={opened}
          close={close}
          mode={'edit'}
          rowId={currentIndex}
          editData={currentDetails}
        />
      )}
    </>
  );
};

export default CarbonNeutralityEditRow;
